import { ExchangeRefundPassenger } from '../../order/model';
import { RefundPassenger } from '../model/passengers/types';
import { getRefundPassengerLabel, getRefundChildIds } from './refundPassengerUtils';

/**
 * Преобразует `RefundPassenger[]` в строки чекбоксов для шага Passengers.
 * Порядок строк: сперва взрослый, затем его дети;
 * "невзрослые" с linkedTraveller === null — в конце(WEBSKY-8562)
 */
export const buildRefundCheckboxPassengers = (
	passengers: RefundPassenger[],
	childRefundWithoutAdultAllowed: boolean
): ExchangeRefundPassenger[] => {
	const checkboxPassengers: ExchangeRefundPassenger[] = [];
	const unlinkedPassengers: ExchangeRefundPassenger[] = [];

	for (const passenger of passengers) {
		if (passenger.type === 'ADT') {
			if (passenger.children?.length) {
				checkboxPassengers.push({
					ids: [passenger.id, ...getRefundChildIds(passenger)],
					label: getRefundPassengerLabel(passenger),
					isSelected: passenger.isSelected,
					isDisabled: passenger.isDisabled ?? false
				});

				if (childRefundWithoutAdultAllowed) {
					for (const child of passenger.children) {
						if (child.type !== 'CLD') {
							continue;
						}

						checkboxPassengers.push({
							ids: [child.id],
							label: getRefundPassengerLabel(child),
							isSelected: child.isSelected,
							isDisabled: child.isDisabled ?? false
						});
					}
				}

				continue;
			}

			checkboxPassengers.push({
				ids: [passenger.id],
				label: getRefundPassengerLabel(passenger),
				isSelected: passenger.isSelected,
				isDisabled: passenger.isDisabled ?? false
			});

			continue;
		}

		if (!passenger.linkedTraveller) {
			unlinkedPassengers.push({
				ids: [passenger.id],
				label: getRefundPassengerLabel(passenger),
				isSelected: passenger.isSelected,
				isDisabled: passenger.isDisabled ?? false
			});
		}
	}

	return [...checkboxPassengers, ...unlinkedPassengers];
};
